// HELPERS
import tableFilter from '../../../../helpers/tableFilter';

// UTILS
import naUTL from '../../../../../../utils/naUTL';

const jsonTableRow = (dataSources) => {
  const {
    watchlistAML,
  } = dataSources;

  const table = [
    {
      col1: 'Status',
      col2: naUTL(watchlistAML.status),
    },
    {
      col1: 'Safe Harbour Score',
      col2: naUTL(watchlistAML.safeHarbourScore),
    },
    {
      col1: 'Identity Verified',
      col2: naUTL(watchlistAML.identityVerified),
    },
    {
      col1: 'First Name Verified',
      col2: naUTL(watchlistAML.verifications.firstName),
    },
    {
      col1: 'Last Name Verified',
      col2: naUTL(watchlistAML.verifications.lastName),
    },
    {
      col1: 'Date Of Birth Verified',
      col2: naUTL(watchlistAML.verifications.dateOfBirth),
    },
    {
      col1: 'Gender Verified',
      col2: naUTL(watchlistAML.verifications.gender),
    },
    {
      col1: 'Email Verified',
      col2: naUTL(watchlistAML.verifications.birthCertificateNo),
    },
    {
      col1: 'Name Match Score',
      col2: naUTL(watchlistAML.nameMatchScore),
    },
  ];

  return tableFilter(table);
};

export default jsonTableRow;
